/**
 * Gallery help system — route → topic map.
 * Scoped to the routes a Gallery actually uses (see app-routing + galleries.routes).
 */
import { RouteHelpMapping } from '../help.types';

export const galleryRouteHelpMap: RouteHelpMapping[] = [
  // Dashboard & onboarding
  { route: '/ds-gallery-dashboard', topic: 'dashboard' },
  { route: '/dashboard', topic: 'dashboard' },
  { route: '/gallery-onboarding-checklist', topic: 'getting-started' },

  // Gallery's own products
  { route: '/galleries/view-gallery-products', topic: 'products/overview' },
  { route: '/galleries/gallery-product/create', topic: 'products/managing' },
  { route: '/galleries/gallery-products/:Id', topic: 'products/managing' },

  // Consigned inventory
  { route: '/galleries/gallery-products', topic: 'consignments/inventory' },
  { route: '/view-consignments', topic: 'consignments/inventory' },
  { route: '/consignment/:consignmentId/consignment-product-selection', topic: 'consignments/accepting' },

  // Connections & sourcing
  { route: '/connected-artists', topic: 'connections/overview' },
  { route: '/galleries/connected-artists', topic: 'connections/overview' },
  { route: '/galleries/requested-products', topic: 'connections/product-requests' },
  { route: '/artist/:artistId', topic: 'connections/viewing-artist' },

  // Proposals
  { route: '/view-proposals', topic: 'proposals/overview' },
  { route: '/galleries/view-proposals', topic: 'proposals/overview' },
  { route: '/galleries/proposal-selection/:id', topic: 'proposals/reviewing' },

  // Marketing & operations
  { route: '/galleries/gallery-shareable-product', topic: 'marketing/shareable' },
  { route: '/labels-generation', topic: 'operations/labels' },

  // Events (gallery-run)
  { route: '/events', topic: 'events/overview' },
  { route: '/events/create', topic: 'events/creating' },

  // Account & messaging
  { route: '/edit-profile', topic: 'account/profile' },
  { route: '/inbox', topic: 'messaging/inbox' },

  // Fallback (must be last)
  { route: '*', topic: 'getting-started' },
];
